// extracted by mini-css-extract-plugin
export default {"base":"style_base__tX0Sl","info":"style_info__Lx80p","root":"style_root__4bXvX"};